import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import * as AOS from 'aos';
import { TeamService } from '../../shared/services/team.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  empId: number | null = null; // Declare empId as number or null
  employee: any;
  isBrowser:boolean=false;
  baseUrl=Constants.baseUrl;

  constructor(private route: ActivatedRoute,private teamService: TeamService,  private titleService: Title,private seoService:SeoService, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta,@Inject(PLATFORM_ID) private platformId: any,) {this.isBrowser=isPlatformBrowser(this.platformId); }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Our Journey | Milestones of Success at Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'We’re a team of forward thinkers, innovators, pioneers and executors who believe that collective knowledge can transform all our futures with a greater purpose.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Our Journey | Milestones of Success at Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/journey/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/techtraining_images/trainingimage1.png' },
      { property: 'og:description', content: 'We’re a team of forward thinkers, innovators, pioneers and executors who believe that collective knowledge can transform all our futures with a greater purpose.' },
    ]);
  }
  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
"@context": "https://schema.org/",
"@type": "Person",
"name": "Prasad Maganti",
"url": "https://mitresource.com/journey/",
"image": "https://mitresource.com/assets/images/journey/prasad_ceosir.png",
"sameAs": "https://www.linkedin.com/in/prasadmaganti/",
"jobTitle": "Founder",
"worksFor": {
  "@type": "Organization",
  "name": "Maganti IT Resources, LLC"
}  
}`;
   
    this._renderer2.appendChild(this._document.head, script);

    if(this.isBrowser){    AOS.init({ disable: 'mobile', duration: 2000, delay: 500 });
  }
  
  this.seoService.createLinkForCanonicalURL();
    this.setTitleAndMetaTags();
    // Retrieve the empId from route parameters and convert to number
    const empIdParam = this.route.snapshot.paramMap.get('empId');
    
    if (empIdParam) {
      this.empId = Number(empIdParam); // Convert string to number
      if (!isNaN(this.empId)) {
        this.getEmployee(this.empId);
        // Use empId as needed for loading profile data
        // console.log(`Employee ID: ${this.empId}`);
      } else {
        // console.error('Invalid Employee ID');
      }
    } else {
      // console.error('Employee ID is missing');
    }

  }
  getEmployee(id: number): void {
    this.teamService.getEmployeeById(id).subscribe(
      (data:any) => {
        this.employee = data; // Assign the API response to the employee property
        // console.log(this.employee);
      },
      (error:any) => {
        // console.error('Error fetching employee data:', error);
      }
    );
  }
  getImageUrl(bannerImage:string){
    if(bannerImage!=null){
   
    return Constants.baseImageUrl + bannerImage;
    }else{
      return '../../../assets/images/InternshipPage/business-conference-banner-template-design-for-webinar-marketing-online-class-program-etc-free-vector.jpg'
    }
      }


}